// Question card shown on the OBS stream (doc §12.3). All text is rendered as
// React text nodes (auto-escaped) — never as HTML — so submitted content can
// never inject markup (doc §9, §22.2).
export function QuestionDisplayCard({
  text,
  name,
}: {
  text: string;
  name: string;
}) {
  return (
    <div className="display-card">
      <div className="display-card-label">QUESTION</div>
      <p className="display-card-text">{text}</p>
      <div className="display-card-name">{name}</div>
    </div>
  );
}
